import React from "react";
import { Alert, Collapse, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useGlobalNotification } from "./GlobalNotificationContext";
import SafeHtml from "../../builderio/custom-components/SafeHtml/SafeHtml";
import InfoIcon from "@mui/icons-material/Info";
import ErrorIcon from "@mui/icons-material/Error";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const GlobalNotification: React.FC = () => {
  const { message, showIcon, type, setNotification } = useGlobalNotification();

  const iconMap = {
    success: <CheckCircleIcon sx={{ color: "#4caf50" }} />,
    error: <ErrorIcon sx={{ color: "#f44336" }} />,
    warning: <InfoIcon sx={{ color: "#ff9800" }} />,
  };

  if (!message) return null;

   const renderMessage = () => {
    if (typeof message === "string") {
      return <SafeHtml as="div" html={message} />;
    } else {
      return message; 
    }
  };


  return (
    <Collapse in={!!message}>      
      <Alert
        className="bar-notification"
        severity={type}
        icon={showIcon ? iconMap[type] : false} 
        sx={{
          display: "flex",
          borderRadius: 0,
          textAlign: "center",
          fontWeight: 500,
          fontSize: "15px",
          "& a": {
            color: "inherit",
            textDecoration: "underline",
          },
        }}
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
            onClick={() => setNotification(null)}
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
      >
          {renderMessage()}
      </Alert>
    </Collapse>
  );
};

export default GlobalNotification;
